export const GET_USERS_LOADING = "get/user/loading";
export const GET_USERS_ERROR = "get/user/error";
export const GET_USERS_SUCCESS = "get/user/success";

export const GET_SINGLE_USERS_LOADING = "get/single/user/loading";
export const GET_SINGLE_USERS_ERROR = "get/single/user/error";
export const GET_SINGLE_USERS_SUCCESS = "get/single/user/success";

export const UPDATE_USERS_LOADING = "UPDATE/user/loading";
export const UPDATE_USERS_ERROR = "UPDATE/user/error";
export const UPDATE_USERS_SUCCESS = "UPDATE/user/success";

export const DELETE_USERS_LOADING = "DELETE/user/loading";
export const DELETE_USERS_ERROR = "DELETE/user/error";
export const DELETE_USERS_SUCCESS = "DELETE/user/success";

export const LOGIN_USERS_LOADING = "LOGIN/user/loading";
export const LOGIN_USERS_ERROR = "LOGIN/user/error";
export const LOGIN_USERS_SUCCESS = "LOGIN/user/success";

export const REGISTER_USERS_LOADING = "REGISTER/user/loading";
export const REGISTER_USERS_ERROR = "REGISTER/user/error";
export const REGISTER_USERS_SUCCESS = "REGISTER/user/success";

export const LOGOUT_USERS_SUCCESS = "REGISTER/user/success";
